'use es6';

import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
import { ListSegClassicTimestampTypes } from './ListSegConstants';
import { Map as ImmutableMap } from 'immutable';
import ListSegClassicOperators from './ListSegClassicOperators';
export const ListTypeToOperator = ImmutableMap(ListSegClassicOperators);
export const OperatorsToListType = ListTypeToOperator.flip();
export const getListSegClassicTimestampType = ({
  type
}) => {
  if (type === PropertyTypes.DATE) {
    return ListSegClassicTimestampTypes.UTC_TZ_ALIGNED;
  }
  return ListSegClassicTimestampTypes.PORTAL_TZ_ALIGNED;
};